import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aad15530")

_pushScopeId("data-v-aad15530")
const _hoisted_1 = { class: "adjustment pt-16" }
const _hoisted_2 = { class: "btm px-16 d-f mt-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheAdjustmentItem = _resolveComponent("TheAdjustmentItem")
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_HoldOn = _resolveComponent("HoldOn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_HoldOn, {
      content: _ctx.options,
      height: 160
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "items mb-12 px-16",
            key: index
          }, [
            _createVNode(_component_TheAdjustmentItem, {
              item: item,
              onChange: _ctx.itemChange
            }, null, 8, ["item", "onChange"])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Pic, {
            src: "user/description",
            width: "16",
            height: "16"
          }),
          _createVNode(_component_t, {
            as: "p",
            class: "f-md c-title ml-8",
            path: "leverage_28"
          })
        ])
      ]),
      _: 1
    }, 8, ["content"])
  ]))
})